

import React from 'react';
import { convertUTCToLocalDateTime } from '../../../../components/dateTime';
import { Box, Button, Avatar } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import invited from '../../../../assets/Dashboard/invited.svg';
// import novacore from '../../../assets/novacore.png';
import profileperson from '../../../../assets/profileperson.png';
import back from "../../../../assets/back.svg"
import CustomText, { textStyles } from '../../../../components/CustomText';
import trial from "../../../../assets/Dashboard/trial.svg";
import company from "../../../../assets/company.png";
import code from "../../../../assets/code.svg";
import CustomButton from "../../../../components/CustomButton";
import active from '../../../../assets/Dashboard/active.svg';
import inactive from '../../../../assets/Dashboard/inactive.svg';

import request from '../../../../assets/Dashboard/request.svg';
import process from "../../../../assets/Dashboard/process.svg";
import overdue from "../../../../assets/Dashboard/overdue.svg";
import received from "../../../../assets/Wallet/received.svg";
import pending from "../../../../assets/Wallet/pending.svg";
import { useTranslation } from "react-i18next";
import { BASE_URL } from '../../../../components/BaseUrl';
import { toast } from 'react-hot-toast';
import { decryptToken } from "../../../../Utlis/Encryption";
import CircularProgress from '@mui/material/CircularProgress';
import StatusDropdown from '../../../../components/StatusDropdown';
import dummy from "../../../../assets/dummy.png";
import imageIcon from "../../../../assets/imageIcon.png";
import document1 from "../../../../assets/document1.svg";
const ClientsRequestDetails = ({ selectedRow, onClose }) => {
  const isMobile = useMediaQuery('(max-width:768px)');
  const { t } = useTranslation();
  const [updatingTo, setUpdatingTo] = React.useState("");
  const [isUpdatingStatus, setIsUpdatingStatus] = React.useState(false);

  const rawEncryptedToken = localStorage.getItem("token");

  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;

  const handleSingleStatusUpdate = async (newStatus) => {
    setIsUpdatingStatus(true);
    setUpdatingTo(newStatus);

    try {
      const res = await fetch(`${BASE_URL}/company-admins/status`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          company_admin_ids: [selectedRow.id || selectedRow.account_details?.id],
          status: newStatus,
          verification_status: selectedRow.verification_status || 'verified',
        }),
      });

      const result = await res.json();

      if (!result.error) {
        toast.success(`Status updated to "${newStatus}"`);
        onClose(); // Close the details screen
      } else {
        toast.error(result.message || "Status update failed");
      }
    } catch (err) {
      console.error("Status update error:", err);
      toast.error(t("Something went wrong"));
    } finally {
      setIsUpdatingStatus(false);
      setUpdatingTo("");
    }
  };
  const statusIcons = {
    Active: active,
    Trial: trial,
    Invited: invited,
    invited: invited,
    Inactive: inactive,
    Requested: request,
    Overdue: overdue,
    Processing: process,
    Paid: active,
    Pending: pending,
    Received: received

  };

  const statusStyles = {
    Active: { backgroundColor: '#4BCE97', color: '#164B35' },
    Trial: { backgroundColor: '#FEA362', color: '#702E00' },
    Invited: { backgroundColor: '#579DFF', color: '#09326C' },
    invited: { backgroundColor: '#579DFF', color: '#09326C' },
    Inactive: { backgroundColor: '#F87168', color: '#5D1F1A' },
    Requested: { backgroundColor: '#F5CD47', color: '#533F04' },
    Paid: { backgroundColor: '#4CD08B', color: '#0E563F' },
    Processing: { backgroundColor: '#FDD35C', color: '#7A4100' },
    Overdue: { backgroundColor: '#FFA26B', color: '#722800' },
    Pending: { backgroundColor: '#F5CD47', color: '#533F04', },
    Received: { backgroundColor: '#4BCE97', color: '#164B35', }
  };
  const rawStatus = selectedRow.status || selectedRow.account_details?.status || "Pending";
  const statusKey = rawStatus.charAt(0).toUpperCase() + rawStatus.slice(1); // e.g., "invited" → "Invited"
  const statusStyle = statusStyles[statusKey] || { backgroundColor: "#eee", color: "#333" };
  const statusIcon = statusIcons[statusKey];



  const [profileImgSrc, setProfileImgSrc] = React.useState(dummy);
  const [companyLogoSrc, setCompanyLogoSrc] = React.useState(dummy);
  const loadImageWithAuth = async (url, setter) => {
    try {
      const res = await fetch(url, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!res.ok) throw new Error("Image fetch failed");
      const blob = await res.blob();
      const objectUrl = URL.createObjectURL(blob);
      setter(objectUrl);
    } catch (err) {
      console.error("Image error:", err);
      setter(dummy);
    }
  };

  React.useEffect(() => {
    if (!selectedRow) return;

    const profileUrl = selectedRow?.account_details?.profile_image;
    const companyUrl = selectedRow?.company_details?.company_logo;

    console.log("API -> profile_image:", profileUrl);
    console.log("API -> company_logo:", companyUrl);

    if (profileUrl) loadImageWithAuth(profileUrl, setProfileImgSrc);
    if (companyUrl) loadImageWithAuth(companyUrl, setCompanyLogoSrc);
  }, [selectedRow, token]);
  const formatSubscription = (value) => {
    if (!value) return "";

    return value
      .replace(/_/g, " ")      // full_monthly → full monthly
      .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize each word
  };


  const formatDateTime = (date) => {
    if (!date) return "-";
    return convertUTCToLocalDateTime(date);
  };
  const getFileName = (url) => {
    if (!url) return "";
    return url.split("/").pop();
  };

  // Check if the URL is image or PDF
  const getFileType = (url) => {
    if (!url) return null;
    const lower = url.toLowerCase();
    if (lower.endsWith(".pdf")) return "pdf";
    if (lower.endsWith(".jpg") || lower.endsWith(".jpeg") || lower.endsWith(".png")) return "image";
    return "other";
  };
  const formatAdminType = (value) => {
    if (!value) return "-";

    return value
      .split("_")                 // ["legal", "entity"]
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");                // "Legal Entity"
  };

  const formatDOB = (date) => {
    if (!date) return "-";
    return convertUTCToLocalDateTime(date, { formatOptions: { year: 'numeric', month: 'long', day: '2-digit' } });
  };

  if (!selectedRow) return null;

  return (
    <>
      <Box
        sx={{
          border: '1px solid #E4E6EF',
          borderRadius: 2,
          px: 2,
          backgroundColor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          minHeight: 55,
        }}
      >
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
          onClick={onClose}
        >
          <img src={back} style={{ width: 30, height: 30 }} />
          <CustomText
            sx={{ ...textStyles.h1, fontWeight: 500, fontSize: '14px', color: '#626F86', textAlign: 'center' }}
          >
            {t("InviteDetails.breadcrumb")}/ {selectedRow.company_details.legal_name}
          </CustomText>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: isMobile ? "column" : "row", gap: 2, mt: 2, }}>
        <Box sx={{ width: isMobile ? "100%" : '50%', }}>

          <Box
            sx={{

              backgroundColor: '#fff',
              borderRadius: 2,
              border: '1px solid #E4E6EF',
              p: 3,
            }}
          >
            <CustomText sx={{ ...textStyles.h1, fontSize: 18, mb: 3, mt: 1, fontWeight: 600, color: '#003149', textAlign: 'left' }}>
              {t("InviteDetails.accountDetails")}
            </CustomText>


            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2 }}>
              <img

                src={profileImgSrc || dummy}
                alt="profile" style={{ width: 140, height: 140, borderRadius: '50%' }} />
            </Box>

            <Box>

              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                  {t("InviteDetails.id")} </CustomText>
                <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                  {selectedRow.account_details.id}  </CustomText>  </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                  {t("InviteDetails.status")}
                </CustomText>

                {/* <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 0.5,
      px: 0.6,
      py: 0.4,
      borderRadius: "4px",
      backgroundColor: statusStyle.backgroundColor,
      color: statusStyle.color
    }}
  >
    {statusIcon && (
      <img src={statusIcon} alt="status" style={{ width: 16 }} />
    )}
    <CustomText sx={{
      fontWeight: 600,
      fontSize: 14,
      color: statusStyle.color
    }}>
      {statusKey}
    </CustomText>
  </Box> */}
                <Box sx={{ pointerEvents: "none" }}>
                  <StatusDropdown
                    currentStatus={selectedRow.account_details.status || "pending"}
                  />
                </Box>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                  {t("InviteDetails.registeredOn")}</CustomText>
                <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "right" }}>
                  {formatDateTime(selectedRow.account_details.registered_on)} </CustomText>  </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                  {t("InviteDetails.companyAdmin")}</CustomText>
                <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "right" }}>
                  {selectedRow.account_details.company_admin} </CustomText>  </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                  {t("InviteDetails.registeredEmail")}</CustomText>
                <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "right" }}>
                  {selectedRow.account_details.registered_email} </CustomText>  </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 16,
                    fontWeight: 400,
                    color: "#5E5C5C",
                    textAlign: "left"
                  }}
                >
                  {t("InviteDetails.dob")}
                </CustomText>

                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 15,
                    fontWeight: 400,
                    color: "#172B4D",
                    textAlign: "left"
                  }}
                >
                  {formatDOB(selectedRow.account_details.dob)}
                </CustomText>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                  {t("InviteDetails.phoneNumber")}</CustomText>
                <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                  {selectedRow.account_details.phone_no || '+34 612 345 678'} </CustomText>  </Box>
            </Box>
          </Box>
          <Box sx={{
            backgroundColor: '#fff',
            borderRadius: 2,
            border: '1px solid #E4E6EF',
            p: 3,
            mt: 2,
          }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 18, mb: 3, mt: 1, fontWeight: 600, color: '#003149', textAlign: 'left' }}>
              {t("InviteDetails.subscriptionDetails")}
            </CustomText>


            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                {t("InviteDetails.subscriptionStatus")} </CustomText>
              {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5,px:0.6,py:0.4,borderRadius:"4px",backgroundColor:"#FEA362",color:"#702E00" }}>
              <img src={trial} alt="status" style={{ width: 16 }} />
       
    <CustomText sx={{ fontWeight: 600, fontSize:14, color: '#702E00' }}>
  {selectedRow.subscription_details.subscription_status || "-"}
</CustomText>
            </Box> */}
              <Box sx={{ pointerEvents: "none" }}>
                <StatusDropdown
                  currentStatus={selectedRow.subscription_details.subscription_status || "trial"}
                />
              </Box>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                {t("InviteDetails.subscription")}</CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left"
                }}
              >
                {Array.isArray(selectedRow.subscription_details.subscription)
                  ? selectedRow.subscription_details.subscription
                    .map(formatSubscription)
                    .join(", ")
                  : formatSubscription(selectedRow.subscription_details.subscription)}
              </CustomText>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                {t("InviteDetails.maxUsers")}</CustomText>
              <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                {selectedRow.subscription_details.max_users}</CustomText>  </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                {t("InviteDetails.duration")}</CustomText>
              <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                {selectedRow.subscription_details.duration}</CustomText>  </Box>


            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                {t("InviteDetails.activationDate")}</CustomText>
              <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "right" }}>
                {formatDateTime(selectedRow.subscription_details.activation_date)}</CustomText>  </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                {t("InviteDetails.expiry")}</CustomText>
              <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
                {formatDateTime(selectedRow.subscription_details.expiry)}</CustomText>  </Box>

          </Box>

        </Box>

        <Box
          sx={{
            width: isMobile ? "100%" : '50%',
            backgroundColor: '#fff',
            borderRadius: 2,
            border: '1px solid #E4E6EF',
            p: 3,
          }}
        >

          <CustomText sx={{ ...textStyles.h1, fontSize: 18, mb: 3, mt: 1, fontWeight: 600, color: '#003149', textAlign: 'left' }}>
            {t("InviteDetails.companyDetails")}
          </CustomText>

          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2 }}>
            <img
              src={companyLogoSrc || dummy}
              alt="profile" style={{ width: 140, height: 140, borderRadius: '50%' }} />
          </Box>
          <CustomText sx={{ ...textStyles.h1, fontSize: 16, mb: 3, mt: 1, fontWeight: 600, color: '#003149', textAlign: 'left' }}>
            {t("InviteDetails.legalDetails")}
          </CustomText>


          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
              {t("InviteDetails.workspaceCode")}</CustomText>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer" }}
              onClick={() => {
                const code = selectedRow?.company_details?.workspace_code;
                if (code) {
                  navigator.clipboard.writeText(code);
                  toast.success(t("copyCodeSuccess"));
                }
              }}
            >
              <Box
                component="img"
                src={code}
                alt="code icon"
                sx={{ width: 20, height: 20 }}
              />

              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "right",
                  userSelect: "text"    // allows direct highlight + copy
                }}
              >
                {selectedRow.company_details.workspace_code}
              </CustomText>
            </Box>
          </Box>


          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
              {t("InviteDetails.legalName")}</CustomText>
            <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
              {selectedRow.company_details.legal_name}</CustomText>  </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
              {t("InviteDetails.businessSector")}</CustomText>
            <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
              {selectedRow.company_details.business_sector_industry}</CustomText>  </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
              {t("InviteDetails.tradeNo")}</CustomText>
            <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
              {selectedRow.company_details.trade_no}</CustomText>  </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
              {t("InviteDetails.businessRegistration")}</CustomText>
            <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
              {selectedRow.company_details.business_registration_no}</CustomText>  </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
              {t("InviteDetails.businessEmail")}</CustomText>
            <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
              {selectedRow.company_details.business_email}</CustomText>  </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
              {t("InviteDetails.businessPhone")}</CustomText>
            <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
              {selectedRow.company_details.business_phone_no}</CustomText>  </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C" }}>
              {t("inviteDetailsExtra.businessActivity")}
            </CustomText>
            <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D" }}>
              {selectedRow.company_details.business_activity || "-"}
            </CustomText>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C" }}>
              {t("inviteDetailsExtra.primaryColor")}
            </CustomText>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ width: 20, height: 20, borderRadius: "4px", bgcolor: selectedRow.company_details.primary_color }} />
              <CustomText sx={{ fontSize: 14, color: "#172B4D" }}>{selectedRow.company_details.primary_color}</CustomText>
            </Box>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C" }}>
              {t("inviteDetailsExtra.secondaryColor")}
            </CustomText>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ width: 20, height: 20, borderRadius: "4px", bgcolor: selectedRow.company_details.secondary_color }} />
              <CustomText sx={{ fontSize: 14, color: "#172B4D" }}>{selectedRow.company_details.secondary_color}</CustomText>
            </Box>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
              {t("inviteDetailsExtra.administratorType")}
            </CustomText>
            <CustomText sx={{ fontSize: 15, color: "#172B4D" }}>
              {formatAdminType(selectedRow.account_details.administrator_type)}

            </CustomText>
          </Box>

          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 16,
              mb: 1,
              mt: 3,
              fontWeight: 600,
              color: "#003149",
              textAlign: "left",
            }}
          >
            {t("inviteDetailsExtra.adminDocument")}
          </CustomText>

          <Box
            sx={{
              border: "1px solid #E4E6EF",
              p: 2,
              borderRadius: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* LEFT SIDE ICON + FILE NAME */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <img
                src={
                  getFileType(selectedRow.company_details.admin_document_url) === "pdf"
                    ? document1
                    : imageIcon
                }
                style={{ width: 28, height: 28 }}
              />

              <CustomText sx={{ fontSize: 14, color: "#172B4D" }}>
                {getFileName(selectedRow.company_details.admin_document_url)}
              </CustomText>
            </Box>

            {/* RIGHT SIDE VIEW BUTTON */}
            <Button
              variant="outlined"
              sx={{ textTransform: "none", fontSize: 12, borderRadius: "6px" }}
              onClick={() =>
                window.open(selectedRow.company_details.admin_document_url, "_blank")
              }
            >
              {t("inviteDetailsExtra.viewDocument")}
            </Button>
          </Box>


          <CustomText sx={{ ...textStyles.h1, fontSize: 16, mb: 3, mt: 3, fontWeight: 600, color: '#003149', textAlign: 'left' }}>
            {t("InviteDetails.addressDetails")}
          </CustomText>

          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
              {t("InviteDetails.country")}</CustomText>
            <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
              {selectedRow.company_address_details.country}</CustomText>  </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
              {t("InviteDetails.province")}</CustomText>
            <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
              {selectedRow.company_address_details.community_province}</CustomText>  </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
              {t("InviteDetails.city")}</CustomText>
            <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
              {selectedRow.company_address_details.city}</CustomText>  </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
              {t("InviteDetails.streetAddress")}</CustomText>
            <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "left" }}>
              {selectedRow.company_address_details.street_address}</CustomText>  </Box>






        </Box>
      </Box>
    </>
  );
};

export default ClientsRequestDetails;